import React from "react";
import MobileStoresItem from "./MobileStoresItem";

const MobileStores = ({ storeCategories }) => {
  return (
    <div className="block lg:hidden">
      <div className="container">
        <div className="overflow-x-auto flex flex-nowrap relative py-2 gap-2.5 md:justify-between mb-2">
          {storeCategories.map((category) => (
            <MobileStoresItem key={category.id} category={category} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default MobileStores;
